<template>
  <span>
      <span v-if="record.promotionRank && record.promotionRank !== null && record.promotionRank > 0 && record.ranking < 0">小组第 <b>{{ record.promotionRank }}</b></span>
      <a-tag v-if="record.ranking === -5" color="#ccc">选手弃权</a-tag>
      <a-tag v-if="record.ranking === -4" color="#ccc">选手失格</a-tag>
      <a-tag v-if="record.ranking === -3" color="#108ee9">选手加赛</a-tag>
      <a-tag v-if="record.ranking === -2" color="#ccc">选手淘汰</a-tag>
      <a-tag v-if="record.ranking === -1" color="#17bf39">晋级成功</a-tag>
      <a-tag v-if="record.ranking > 0" color="#b80000">第<b style="color:white;"> {{ record.ranking }} </b>名</a-tag>
      <a-tag v-if="record.ranking === 0" color="#cccccc">暂无名次</a-tag>
      <b v-if="record.victoryType !== null">成绩：{{ record.blueTotalScore }}</b>
  </span>
</template>

<script>
export default {
  name: 'ResultTag',
  components: {
  },
  data () {
    return {
    }
  },
  props: {
    record: {
      type: Object
    }
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/comm/components/modal/ResultScoreTag.vue